<template>
  <div class="Component quote-news" v-if="quoteHtml">
    <blockquote>
      <p v-html="quoteHtml"></p>
      <p v-if="author" class="author">{{ author }}</p>
    </blockquote>
  </div>
</template>

<script>
import { renderPrismicContent } from '../helpers/prismicHelpers';

export default {
  name: 'QuoteComponent',
  props: {
    sliceData: {
      type: Object,
      required: true
    },
    prismicLang: {
      type: String,
      required: true
    }
  },
  computed: {
    quoteHtml() {
      const quoteArray = this.sliceData?.primary?.quote;
      if (!quoteArray || !Array.isArray(quoteArray) || quoteArray.length === 0) {
        return '';
      }
      return renderPrismicContent(quoteArray);
    },
    author(){
      return this.sliceData?.primary?.quote_author || '';
    }
  }
};
</script>
